import { parseTime } from '@/utils/index.js' 
export default {
  name: "processTimeline",
  data() {
    return {
      timeline: [],
    }
  },
  methods: {
    getTimeline(postData) {
      this.timeline = []
      console.log('获取时间轴：', postData.processInstanceId);
      
      const params = {
        processInstanceId: postData.processInstanceId,
      }
      this.$api.workflowTimeLine(params).then((res) => {
            if(res.code === 0){
              let timeline =res.data.timelineList
              let userInfoMap= res.data.userInfoMap
              // 拼装用户信息
              timeline.forEach(e => {
                if(e.type==='START' || e.type==='REVOKE' || e.type==='TRANSFER'|| e.type==='SIGN'|| e.type==='COMMENT'){
                  if ( e.operatorId) {
                    // 发起人 已撤销
                    let user = userInfoMap[e.operatorId]
                    e.userInfo =(user.dept?user.dept + ' ':'') + user.name + ' ' + (user.isLeave?'(已离职)' : '')
                    if(e.type==='TRANSFER'){
                      let user = userInfoMap[e.attributes.transferUserId]|| {}
                      e.transferUser = user.name || '未知'
                    }else if(e.type==='SIGN'){
                      let user = userInfoMap[e.attributes.signUserId]|| {}
                      e.signUser = user.name || '未知2'
                    }
                  }else if(e.type==='TRANSFER'){
                    // 无操作ID 为自动转交的
                    let user = userInfoMap[e.attributes.transferUserId]|| {}
                      e.newUser = (user.dept?user.dept + ' ':'') + user.name + ' ' + (user.isLeave?'(已离职)' : '')
                  }
                  
                }else if(e.type==='APPROVE'){
                    if (e.operatorId) {
                       // 审批人 一个 有操作人
                      let user = userInfoMap[e.operatorId]
                      e.userInfo =(user.dept?user.dept + ' ':'') + user.name + ' ' + (user.isLeave?'(已离职)' : '')
                      if(!e.createTime && e.descInfo==='审批中'){
                        const customFormat = '{y}-{m}-{d} {h}:{i}'; 
                        e.nowTime = parseTime(new Date(),customFormat)
                      }
                      // 前后加签标记
                      if(e.attributes && e.attributes.signTpe){
                        e.signText = e.attributes.signTpe ==='BEFORE'?'前加签':'后加签'
                      }
                    }else{
                      // 审批人为空样式处理
                      e.noUser = true
                      if (e.descInfo==='审批通过') {
                        e.noUserText ='自动通过'
                      }else if (e.descInfo==='驳回') {
                         e.noUserText ='自动拒绝'
                      }
                    } 
                }else if(e.type==='MULTI_APPROVE' && e.attributes && e.attributes.approveUserIdList){
                   // 审批人 多个
                  //  let temp = e.attributes.approveUserIdList.map(id => {
                  //     let user = userInfoMap[id];
                  //     return user ? ((user.dept?user.dept + ' ':'') + user.name + ' ' + (user.isLeave ? '(已离职)' : '')) : '';
                  //   }).join('、');
                  let temp = e.attributes.approveUserIdList.map(id => {
                    let user = userInfoMap[id];
                    return{
                      name: user ? ((user.dept?user.dept + ' ':'') + user.name + ' ' + (user.isLeave ? '(已离职)' : '')) : '',
                    }
                  })
                  e.userInfo = temp
                  e.userCount =  e.attributes.approveUserIdList.length
                  e.mode = e.attributes.mode ==='AND'?'会签':'或签' 
                  e.showAll = e.userCount <= 6 
                  if(!e.createTime && e.descInfo==='审批中'){
                      const customFormat = '{y}-{m}-{d} {h}:{i}'; 
                      e.nowTime = parseTime(new Date(),customFormat)
                    }
                }else if(e.type==='ORSIGNCC' && e.attributes && e.attributes.ccUserList){
                  // 或签 抄送 多人
                  let ids = e.attributes.ccUserList.map(item => item.userId);
                  let userCount = ids.length
                  // let temp = ids.map(id => {
                  //   let user = userInfoMap[id]
                  //   return user ? ((user.dept?user.dept + ' ':'') + user.name + ' ' + (user.isLeave ? '(已离职)' : '')+(user.isRead?'<span style="color:#00B498">(已读)</span>':'(未读)')) : '';
                  // }).join('、');
                  // todo 后端 未返抄送人信息，和已读状态
                  let temp = e.attributes.ccUserList.map(item => {
                    let user = userInfoMap[item.userId] || {name:'未知'}
                    return{
                      name: user ? ((user.dept?user.dept + ' ':'') + user.name + ' ' + (user.isLeave ? '(已离职)' : '')) : '',
                      isRead:item.isRead || 0
                    }
                  })
                  let isReadCount =  e.attributes.ccUserList.filter(item => item.isRead == 1).length // 已读个数
                  let read = {}
                  if(isReadCount===0){
                    read.text = '全部未读'
                    read.icon = 'unread'
                  }else if(userCount===isReadCount){
                    read.text = '全部已读'
                    read.icon = 'suc'
                    read.color = 'suc'
                  }else{
                    read.text = '部分已读'
                    read.icon = 'ing'
                  }
                  e.userInfo = temp || '未知'
                  e.userCount = userCount // 抄送人个数
                  e.read = read 
                  e.showAll = userCount <= 6 
                }else if(e.type==='CC' && e.attributes && e.attributes.ccUserList){
                  // 抄送人
                  let ids = e.attributes.ccUserList.map(item => item.userId);
                  let userCount = ids.length
                  // let temp = ids.map(id => {
                  //   let user = userInfoMap[id];
                  //   return user ? ((user.dept?user.dept + ' ':'') + user.name + ' ' + (user.isLeave ? '(已离职)' : '')+ (e.executed ? (user.isRead ? '<span style="color:#00B498">(已读)</span>' : '(未读)') : '')) : '';
                  // }).join('、'); // 已创建抄送才统计已读未读
                  let temp = e.attributes.ccUserList.map(item => {
                    let user = userInfoMap[item.userId];
                    return{
                      name: user ? ((user.dept?user.dept + ' ':'') + user.name + ' ' + (user.isLeave ? '(已离职)' : '')) : '',
                      isRead:item.isRead
                    }
                  })
                  let read = {}
                  if(e.executed){
                    let isReadCount =  e.attributes.ccUserList.filter(item => item.isRead == 1).length // 已读个数
                    if(isReadCount===0){
                      read.text = '全部未读'
                      read.icon = 'unread'
                    }else if(userCount===isReadCount){
                      read.text = '全部已读'
                      read.icon = 'suc'
                      read.color = 'suc'
                    }else{
                      read.text = '部分已读'
                      read.icon = 'ing'
                    }
                  }
                  e.userInfo = temp
                  e.userCount = userCount // 抄送人个数
                  e.read = read
                  e.showAll = userCount <= 6 
                }
              })
              this.timeline = timeline
              console.log('时间轴：', this.timeline , userInfoMap)
            }
          }).finally(()=>{
            this.visible = true
          });
    },
    
  },
}